package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.anjuros.website.redesign.util.rdList

private val FeatureStages = listOf(
    RdText.PORTAL_STAGE1_ACTIONS, RdText.PORTAL_STAGE2_ACTIONS, RdText.PORTAL_STAGE3_ACTIONS,
    RdText.PORTAL_STAGE4_ACTIONS, RdText.PORTAL_STAGE5_ACTIONS, RdText.PORTAL_STAGE6_ACTIONS,
)

/** JSON-LD for the Portal page: the portal as a business app with its features, the breadcrumb and the FAQ. */
@Composable
fun portalStructuredData(): String {
    val description = LocalText(RdText.PORTAL_META_DESCRIPTION)
    val features = FeatureStages.flatMap { rdList(LocalText(it)) }.joinToString(",") { jsonString(it) }
    val breadcrumb = rdBreadcrumbJsonLd(RdText.PORTAL_CRUMB, RdRoute.PORTAL)
    val faq = rdFaqJsonLd(PortalFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"SoftwareApplication","name":"Job Management Portal","applicationCategory":"BusinessApplication",
          "operatingSystem":"Web browser","url":"$SITE_URL${RdRoute.PORTAL}","description":${jsonString(description)},
          "publisher":{"@id":"$SITE_URL/#business"},"featureList":[$features]},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
